import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ButtonComponent } from 'app/layout/common/button/button.component';
import { CloseButtonComponent } from 'app/layout/common/button/close-button.component';
import { MatDialogService } from 'app/shared/services/material/mat-dialog.service';
import { ConfirmationListDialogData, ConfirmationListDialogResult } from './confirmation-list-dialog.types';

@Component({
    selector: 'tms-confirmation-list-dialog',
    standalone: true,
    imports: [
        CloseButtonComponent,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        ButtonComponent
    ],
    templateUrl: './confirmation-list-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationListDialogComponent {
    readonly data = inject<ConfirmationListDialogData>(MAT_DIALOG_DATA);
    private readonly _matDialogService = inject(MatDialogService);
    private readonly _dialogRef = inject(MatDialogRef<ConfirmationListDialogComponent, ConfirmationListDialogResult | undefined>);

    dismiss(): void {
        this._matDialogService.close(this._dialogRef);
    }

    cancel(): void {
        this._matDialogService.close(this._dialogRef, false, 'cancelled');
    }

    confirm(): void {
        this._matDialogService.close(this._dialogRef, false, 'confirmed');
    }
}
